import { sort2dObjsbyVector } from "./index37.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { Vector3toV3, applyTransform, getPivot } from "@project-rouge/rg-three";
function getCorridorCorners(module, apartment) {
	if (apartment.data.closeCorridor && apartment.data.closeDirection) {
		const dir = [apartment.data.closeDirection[0], apartment.data.closeDirection[2]];
		const modules = sort2dObjsbyVector(apartment.children.filter((ch) => ch.type === RG_TYPE.Module), dir);
		if (module.uuid === modules[modules.length - 1].uuid && modules.length > 1) {
			const z = getPivot([
				0,
				0,
				1
			], modules[0]).z;
			const relativeStart = getPivot([
				0,
				0,
				1
			], module);
			const relativeEnd = getPivot([
				1,
				0,
				1
			], module);
			const relativeCorrStart = [
				relativeStart.x,
				relativeStart.y,
				z
			];
			const relativeCorrEnd = [
				relativeEnd.x,
				relativeEnd.y,
				z
			];
			return {
				start: Vector3toV3(applyTransform(relativeCorrStart, apartment)),
				end: Vector3toV3(applyTransform(relativeCorrEnd, apartment))
			};
		}
	}
	return {
		start: Vector3toV3(applyTransform(getPivot([
			0,
			0,
			1
		], module), apartment)),
		end: Vector3toV3(applyTransform(getPivot([
			1,
			0,
			1
		], module), apartment))
	};
}
export { getCorridorCorners };

//# sourceMappingURL=index104.js.map